import { Component, OnInit, Input } from '@angular/core';
import { MainService } from '../../../services/main.service';

@Component({
  selector: 'app-skills-cover',
  templateUrl: './skills-cover.component.html',
  styleUrls: ['./skills-cover.component.scss']
})
export class SkillsCoverComponent implements OnInit {

  @Input() highlight;
  @Input() cover;

  constructor(public mainService: MainService) { }

  ngOnInit() { }

}
